import { render, staticRenderFns } from "./ArticlesCollection.vue?vue&type=template&id=d6d42980"
import script from "./ArticlesCollection.vue?vue&type=script&lang=js"
export * from "./ArticlesCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports